import { render, staticRenderFns } from "./albertcarbonfootprint.vue?vue&type=template&id=6f124b14&"
import script from "./albertcarbonfootprint.vue?vue&type=script&lang=js&"
export * from "./albertcarbonfootprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports